import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import PayPalSuccess from "@/pages/PayPalSuccess";
import Admin from "@/pages/Admin";
import Intake from "@/pages/Intake";
import { Impressum, Datenschutz, AGB, Widerruf } from "@/pages/Legal";
import { CookieBanner } from "@/components/CookieBanner";

function App() {
  return (
    <div className="bg-[#050505] min-h-screen text-[#F5F5F5]">
      <div className="grunge-overlay" />
      <div className="scanlines" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/success" element={<Success />} />
          <Route path="/paypal-success" element={<PayPalSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/widerruf" element={<Widerruf />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "#111111", color: "#F5F5F5", border: "1px solid #39FF14", borderRadius: 0 },
        }}
      />
    </div>
  );
}

export default App;
